import {BellOutlined} from '@ant-design/icons'
import {Avatar, Button} from 'antd'
import {user_getFollowersByUser_Api} from 'apis'
import ContentContainer from 'components/ContentContainer'
import ImageLoader from 'components/ImageLoader'
import Modal from 'components/Modal/Modal'
import Toggle from 'components/Toggle'
import getLinkToDetail from 'helpers/getLinkToDetail'
import {createNumberFormater} from 'helpers/number'
import {LazyPagination} from 'modules/asyncCache/components/LazyPagination'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import {ReactReduxContext} from 'react-redux'
import {Link} from 'react-router-dom'
import {getLogin} from 'redux/selectors'
import ServerContext from 'views/Server/ServerContext'
import {UseFollow} from '../Server/ServerContainer'
import {RiUser2Fill} from "react-icons/ri";
import classNames from "classnames";
import {renderIf} from "../Shared";
import {LayoutContext} from "../../components/layouts/Default/LayoutContext";
import {IoGift} from "react-icons/io5";
import {BiSolidChurch} from "react-icons/bi";
import {BsPersonFill} from "react-icons/bs";
import TooltipApp from "components/TooltipApp";
import getAliasName from "../../helpers/getAliasName";
import {formatDate} from "../../helpers/datetimeHelpers";

export const PageDetailHeader = ({
                                   follow_status,
                                   item,
                                   onFollow,
                                   avatar,
                                   cover,
                                   title,
                                   subTitle,
                                   id,
                                 }) => {
  const t = useTranslate()
  const {store} = useContext(ReactReduxContext)
  const login = getLogin(store.getState())
  const isOwner = login && login.username === item.username
  const {isSm} = useContext(LayoutContext)
  const _height = isSm ? 200 : 260

  return (
    <div
      style={{
        position: 'relative',
        height: _height,
      }}
      className="background">
      {!isOwner && (
        <Button
          icon={<BellOutlined/>}
          className="font-semibold z-10 absolute mt-3 mr-3 top-0 right-0"
          shape="round"
          ghost={!!follow_status}
          onClick={onFollow}
          type="primary">
          {!!follow_status ? t('following') : t('follow')}
        </Button>
      )}
      <ImageLoader
        style={{
          top: 0,
          left: 0,
          position: 'absolute',
          width: '100%',
          height: _height,
          objectFit: 'cover',
        }}
        loadedClassName="rounded-b-lg"
        src={cover}
      />
      <div
        style={{
          top: 0,
          left: 0,
          position: 'absolute',
          width: '100%',
          height: _height,
          objectFit: 'cover',
          backgroundImage: 'linear-gradient(to bottom, rgb(0 0 0 / 0%) 20%, #000000ab 100%)',
          borderBottomLeftRadius: '0.5rem',
          borderBottomRightRadius: '0.5rem',
        }}
      />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          bottom: 20,
          left: 0,
          position: 'absolute',
          width: '100%',
          padding: '0.9em',
        }}>
        <div className="flex flex-col flex-center gap-2">
          <div className="relative">
              <Avatar
                  size={isSm ? 80 : 100}
                  src={avatar}
                  icon={<RiUser2Fill size={isSm ? 40 : 50} className="text-color-500"/>}
                  className="flex flex-center border-4 border-white background-200"
              />
              <div
                  style={{
                      bottom: 0,
                      right: 0,
                      width: isSm ? 18 : 20,
                      height: isSm ? 18 : 20,
                      borderRadius: 999,
                      background: item?.active === 1 ? '#48bb78' : 'var(--text-color-400)',
                      borderWidth: 3,
                      borderColor: item?.active === 1 ?'#fff' : '#e6e6e6',
                      boxShadow: '1px 2px 3px 0px #393939',
                  }}
                  className="absolute"
              />
          </div>
          <div className="w-full flex flex-col items-center">
            <Link
              to={getLinkToDetail(item)}
              className="text-white hover:text-white opacity-85 hover:opacity-100 no-underline">
                {renderIf(
                    item?.patron_saint,
                    <span className="mr-1 font-medium text-base italic">
                        {getAliasName(item, 'patron_saint')}
                    </span>
                )}
                <span className="font-bold text-lg tracking-wider truncate">
                    {title}
                </span>
            </Link>
            <div className="text-xs text-color-500 leading-snug italic opacity-85 tracking-wider">
              {subTitle}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const renderItem = (item, i) => {

  if (!item) return null

  return (
    <Translate>
      {(t) => (
        <div key={i}
             className="w-full flex items-center gap-2 p-2 border border-color-50 hover:shadow-items-md rounded-lg">
          <Avatar
            size={30}
            src={item.avatar}
            shape={item._type === 'user' ? 'circle' : 'square'}
            icon={item._type === 'user' ? <BsPersonFill size={14} className="text-color-500"/> :
              <BiSolidChurch size={14} className="text-color-500"/>}
            className="flex flex-center background-200"
          />
          <div className="flex flex-col gap-1 flex-1">
            <Link
              to={getLinkToDetail(item)}
              className="font-bold cursor-pointer leading-snug no-underline">
              {item.title || item.name}
            </Link>
          </div>
          <UseFollow
            follow_status={item.follow_status}
            owner_id={item.id || item.username}
            owner_type={item._type}>
            {(handleFollow) => {
              return (
                <Button
                  size="small"
                  type={!!item.follow_status ? "default" : "primary"}
                  style={{
                    height: 21,
                    fontSize: 11,
                    padding: '0 12px',
                  }}
                  onClick={() => handleFollow()}
                  className={classNames(
                    "flex flex-center button-rounded-full no-border leading-tight",
                    !!item.follow_status ? 'background-200 hover:bg-primary-100 text-color-300 hover:text-primary-600' : 'text-white'
                  )}>
                  {item.follow_status ? t('following') : t('follow back')}
                </Button>
              )
            }}
          </UseFollow>
        </div>
      )}
    </Translate>
  )
}

function PageDetail({}) {
  const translate = useTranslate()
  const {contextMenu, item, onFollow} = useContext(ServerContext)
  const currentDate = new Date()

  const _isBirthday = formatDate(item?.date_of_birth,'DD/MM') === formatDate(currentDate, 'DD/MM')


  return (
    <div>
      <ContentContainer>
        <PageDetailHeader
          item={item}
          follow_status={item.follow_status}
          onFollow={onFollow}
          cover={item.cover_photo}
          avatar={item.avatar}
          title={item.name}
          subTitle={item.email}
          contextMenu={contextMenu}
          translate={translate}
        />
      </ContentContainer>
      <ContentContainer className="flex items-center gap-3 px-2 mt-5">
        <div className="flex flex-wrap flex-1 gap-3 md:gap-4">
          {[
            ['channels', item.total_channels],
            [
              'followers',
              item.total_followers,
              (isToggle, toggle) => (
                <Modal
                  maskClosable
                  className="custom-modal"
                  onCancel={toggle}
                  open={isToggle}
                  footer={null}
                  title={
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                      {translate('followers')}
                    </div>
                  }>
                  <div className="space-y-3">
                    <div className="font-medium text-sm text-color-400 border-b tracking-wide uppercase">
                      {translate('list of followers')}
                    </div>
                    <LazyPagination
                      apiInfo={user_getFollowersByUser_Api}
                      query={{':username': item.username,}}
                      renderItem={renderItem}
                    />
                    <div className="h-4"/>
                  </div>
                </Modal>
              ),
            ],
          ].map(([text, count, renderModal]) => (
            <Toggle key={text}>
              {(isToggle, toggle) => {
                return (
                  <>
                    <div
                      onClick={toggle}
                      className={classNames(
                        "p-2 md:p-3 flex flex-col border border-color-50 shadow-items-xs rounded-lg",
                        renderModal && 'hover:border-color-base hover:shadow-out cursor-pointer'
                      )}>
                                            <span
                                              className="font-medium text-xs md:text-sm text-color-500 uppercase tracking-wide">
                                                {translate(text)}
                                            </span>
                      <div className="text-right font-bold text-xl leading-tight">
                        {createNumberFormater(translate)(count.toLocaleString())}
                      </div>
                    </div>
                    {renderModal && renderModal(isToggle, toggle)}
                  </>
                )
              }}
            </Toggle>
          ))}
        </div>
        {renderIf(
          _isBirthday,
          <div className="box bounce-7">
            <TooltipApp title="Happy birthday to you !" placement="left" classNames={{ root: "font-medium text-sm italic" }}>
              <IoGift
                size={30}
                className="text-green-300 hover:text-green-700 cursor-pointer"
              />
            </TooltipApp>
          </div>
        )}
      </ContentContainer>
    </div>
  )
}

export default PageDetail
